import React from "react";
import "../styles/InfoDocumentos.css";
import { useAuth } from "../context/AuthContext.jsx";
import FileManager from "./FileManager.jsx";
import { Handshake } from 'lucide-react';

const InfoConvenios = () => {
  const { isAdmin } = useAuth();
  return (
      <div className="doc-page-container" style={{'--doc-color': '#21618c', '--doc-bg-color': '#eaf2f8'}}>
        <div className="doc-page-card">
          <div className="doc-page-header">
            <div className="doc-page-icon"><Handshake size={48} /></div>
            <h2 className="doc-page-title">Convenios</h2>
          </div>
          <p className="doc-page-text">Convenios vigentes firmados por la <strong>Comuna de Santo Domingo</strong> con diversas instituciones.</p>
          <FileManager tableName="convenios_files" folderName="convenios"  isAdmin={isAdmin} />
        </div>
      </div>
  );
};
export default InfoConvenios;